// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".classification-result__success {\n  text-align: center;\n}\n\n.classification-result__breed {\n  color: #018561;\n  font-weight: 700;\n}\n\n.classification-result__loader {\n  margin-bottom: 0.5rem;\n}\n\n.classification-result__classifying {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
